import { TThunkAction } from '../../types/redux';
import { openLoginPopup } from './actions';

export const openLoginPopupAction = (): TThunkAction => {
  return dispatch => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup();
    }

    dispatch(openLoginPopup());
  };
};
